import { apiFetch } from '$lib/api/helpers';
import type {
	CreateDinModuleRequest,
	DinModuleAssignRCURequest,
	DinModuleRequest,
	DinModuleResponse
} from '$lib/types/din_module';

const PATH = '/dinmodules/';

export async function fetchDinModules() {
	return apiFetch<Array<DinModuleResponse>>(`${PATH}`, { method: 'GET' });
}

export async function createDinModule(createRequest: CreateDinModuleRequest) {
	const { rcu, ...payload } = createRequest;
	const created = await apiFetch<DinModuleResponse>(`${PATH}`, {
		method: 'POST',
		body: JSON.stringify(payload)
	});
	return assignRCU(created.id, rcu);
}

export async function deleteDinModule(id: number) {
	return apiFetch<void>(`${PATH}${id}/`, { method: 'DELETE' });
}

export async function updateDinModule(id: number, dinModuleRequest: DinModuleRequest) {
	return apiFetch<DinModuleResponse>(`${PATH}${id}/`, { method: 'PATCH', body: JSON.stringify(dinModuleRequest) });
}

export async function assignRCU(id: number, rcu: number | null) {
	return apiFetch<DinModuleResponse>(`${PATH}${id}/assign_rcu/`, {
		method: 'POST',
		body: JSON.stringify({ rcu } satisfies DinModuleAssignRCURequest)
	});
}
